import { useEffect, useState } from "react";
import chatSocketService from "../../../services/websocket";
import { sendVibrationReaction, listenToVibrationReactions } from "../../../services/socketChatService";

// Custom Hook: useVibrationReactions
export const useVibrationReactions = (venueUUID, currentUser) => {
  const [incomingVibrations, setIncomingVibrations] = useState([]);

  useEffect(() => {
    if (!venueUUID || !chatSocketService.connected) {
      setIncomingVibrations([]);
      return;
    }

    const unsubscribe = listenToVibrationReactions(
      venueUUID,
      (vibrations, error) => {
        if (error) {
          console.error("Vibration reactions dinleme hatası:", error);
          return;
        }

        console.log("📳 Hook'a gelen vibration reactions:", vibrations);
        console.log("📳 Current user ID:", currentUser?.id);

        // Sadece başka kullanıcılardan gelen vibration'ları işle
        const otherUsersVibrations = vibrations.filter(
          (vibration) => vibration.senderId !== currentUser?.id
        );

        console.log("📳 Filtrelenmiş vibration reactions:", otherUsersVibrations);
        setIncomingVibrations(otherUsersVibrations);
      }
    );

    return () => unsubscribe();
  }, [venueUUID, currentUser?.id]);

  const sendVibration = async () => {
    if (!venueUUID || !currentUser || !chatSocketService.connected) {
      throw new Error("Bağlantı yok veya kullanıcı bilgisi eksik");
    }

    try {
      const sender = {
        id: currentUser.id,
        name: currentUser.name,
        avatar: currentUser.avatar,
      };

      await sendVibrationReaction(venueUUID, sender);
    } catch (error) {
      console.error("Vibration reaction gönderme hatası:", error);
      throw error;
    }
  };

  return { incomingVibrations, sendVibration };
}; 